// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c546e35d","455":"30e7bab4","977":"68c6761b"}[chunkId] + ".chunk.js";
};